import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { Router, useNavigate, Navigate } from "react-router-dom";

// Routes
import NewOrders from "../orders/new-orders/NewOrders";
import CurrentOrders from "../orders/current-orders/CurrentOrders";
import DeliveredOrders from "../orders/delivered-orders/DeliveredOrders";
import ProviderSetParameter from "../setting/parameter/ProviderSetParameter";
import ProviderMessages from "../messages/ProviderMessages";
import Chats from "../chats/Chats";
import ProviderCurrentOrders from "../orders/current-orders/ProviderCurrentOrders";
import ProviderPrintOrderDetailsByBangle from "../orders/current-orders/ProviderPrintOrderDetailsByBangle";
import ProviderPrintGeneralOrderByBangle from "../orders/current-orders/ProviderPrintGeneralOrderByBangle";
import NeedConfirmedOrders from "../orders/need-confirmed/NeedConfirmedOrders";
import ProviderPrintGeneralNewOrderByBangle from "../orders/new-orders/ProviderPrintGeneralNewOrderByBangle";
import ProviderPrintGeneralCompleteOrderByBangle from '../orders/delivered-orders/ProviderPrintGeneralCompleteOrderByBangle';
import ProviderNewOrder from "../orders/new-orders/ProviderNewOrder";
import ProviderPrintNewGeneralOrderByBangle from '../orders/new-orders/ProviderPrintNewGeneralOrderByBangle';

const ProducerRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/p-new-orders" />} />
        <Route path="/p-new-orders" element={<ProviderNewOrder />} />
        <Route path="/p-progress-orders" element={<ProviderCurrentOrders />} />
        <Route path="/p-delivered-orders" element={<DeliveredOrders />} />
        <Route
          path="/p-need-confirmed-orders"
          element={<NeedConfirmedOrders />}
        />
        {/* <Route
          path="/print-report-details-by-bangle/:id"
          element={<ProviderPrintOrderDetailsByBangle />}
        /> */}

        <Route
          path="/print-customers-current-orders-by-bangle/:unique_id/:bangle_name/:brand/:status/:zero_status"
          element={<ProviderPrintGeneralOrderByBangle />}
        />
        <Route
          path="/print-customers-new-orders-by-bangle/:unique_id/:bangle_name/:brand/:status/:zero_status"
          element={<ProviderPrintNewGeneralOrderByBangle />}
        />
        <Route
          path="/print-customers-new-orders-by-bangle/:unique_id"
          element={<ProviderPrintGeneralNewOrderByBangle />}
        />

        <Route
          path="/print-customers-complete-orders-by-bangle"
          element={<ProviderPrintGeneralCompleteOrderByBangle />}
        />

        <Route
          path="/setting-set-parameter"
          element={<ProviderSetParameter />}
        />
        {/*..................Chats................... */}
        <Route path="/chats" element={<Chats />} />
        <Route path="/messages" element={<ProviderMessages />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};
export default ProducerRoutes;
